import { axiosInstance } from "../axios";
import { user_apis } from "../ApiConst";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";

/**
 * @template T
 * @typedef {import("axios").AxiosResponse<T>} AxiosResponse
 */
/**
 * @template T
 * @typedef {import("./types/base.types").BaseAPIResponse<T>} BaseAPIResponse
 */
/** @typedef {import("./types/base.types").BaseAPIMessageResponse} BaseAPIMessageResponse */
/** @typedef {import("./types/user.types").CustomerProfileData} CustomerProfileData */
/** @typedef {import("./types/user.types").Gender} Gender */
/** @typedef {import("./types/address.types").UserAddressListResponse} UserAddressListResponse */
/** @typedef {import("./types/address.types").AddUserAddressPayload} AddUserAddressPayload */
/** @typedef {import("./types/address.types").UpdateUserAddressPayload} UpdateUserAddressPayload */
/** @typedef {import("./types/address.types").UserAddressMessageResponse} UserAddressMessageResponse */
/** @typedef {import("./types/address.types").AddressType} AddressType */

/**
 * @param {string} first
 * @param {string} last
 * @param {string} userNum - Exactly 10 digits; "" clears it
 * @param {string} email - Changing it resets `is_verified` to false
 * @param {File | null} [imageFile] - Max 1.2 MB; skipped when empty
 * @param {Gender | ""} [gender] - Skipped when empty
 * @param {string} [dateOfBirth] - YYYY-MM-DD; skipped when empty
 * @returns {Promise<AxiosResponse<BaseAPIResponse<CustomerProfileData>>>}
 */
export const Edit_User_Details = async (
  first,
  last,
  userNum,
  email,
  imageFile,
  gender,
  dateOfBirth
) => {
  let params = new FormData();
  // Append form data fields to the FormData object
  imageFile && params.append("image", imageFile);
  params.append("first_name", first);
  params.append("last_name", last);
  // params.append("display_name", "");
  // params.append("bio", "");
  params.append("mobile_number", userNum);
  // params.append("address", "");
  // params.append("post_code", "");
  // params.append("country", "");
  // params.append("state", "");
  params.append("email", email);
  // params.append("gender", "");
  // params.append("type", "");
  // params.append("code", "");
  // params.append("recommended_by", "");
  // params.append("referrals", "");
  // params.append("blance", "");
  // params.append("request", "");
  // params.append("date_of_birth", "");
  // params.append("date", "");
  // params.append("date_update", "");
  if (gender) params.append("gender", gender);
  if (dateOfBirth) params.append("date_of_birth", dateOfBirth);

  //   let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
  let userId = localStorage.getItem(STORAGE_CONSTANTS.USER_ID);
  // console.log(userToken1, "ffffffffffff");

  //   return await axios.put(`${base_url}api/v0/auth/user/${userId}/`, params, {
  //     headers: {
  //       "Content-Type": "multipart/form-data",
  //       Authorization: "Token " + userToken1,
  //     },
  //   });
  
  return await axiosInstance.put(user_apis.edit_user_details(userId), params, {
    useUserToken: true,
    headers: {
    "Content-Type": "multipart/form-data",
  },
  });
};

/**
 * @returns {Promise<AxiosResponse<BaseAPIResponse<CustomerProfileData>>>}
 */
export const Get_User_Details = async () => {
  try {
    // const token = "9i8h7g6f-5e4d-3c2b-1a0j-dcba098765fe";
    //   let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
    // let userId = localStorage.getItem(STORAGE_CONSTANTS.USER_ID);

    //   return await axios.get(`${base_url}api/v0/auth/user/${userId}/`, {
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: "Token " + userToken1,
    //     },
    //   });
    return await axiosInstance.get(user_apis.get_user_details(), {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};
//not added to index file
export const verifyEmail = async (verifyOTP) => {
  try {
    const userId = localStorage.getItem(STORAGE_CONSTANTS.USER_ID);
    const data = {
      email_otp: verifyOTP,
    };
    return await axiosInstance.post(user_apis.verify_email(userId), data, {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

export const OTP_TO_VERIFY_EMAIL = async () => {
  try {
    const userId = localStorage.getItem(STORAGE_CONSTANTS.USER_ID);
    return await axiosInstance.get(user_apis.otp_to_verify_email(userId), {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

/**
 * @param {string | null} [userToken] - Unused; the axios interceptor adds the token
 * @returns {Promise<AxiosResponse<UserAddressListResponse>>}
 */
export const Saved_Address = async (userToken) => {
  try {
    return await axiosInstance.get(user_apis.saved_address(), {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

/**
 * 406 with UserAddressErrorResponse on validation failure.
 * @param {string | null} [userToken] - Unused; the axios interceptor adds the token
 * @param {{ addressType: AddressType | "", isDefault?: boolean }} formData
 * @param {Record<string, string>} data - Address form values
 * @param {string} address - Goes to `address_str`
 * @returns {Promise<AxiosResponse<UserAddressMessageResponse>>}
 */
export const Add_Address = async (userToken, formData, data, address) => {
  try {
    /** @type {AddUserAddressPayload} */
    const params = {
      first_name: data.firstName,
      last_name: data.lastName,
      email: data.email,
      type: formData.addressType,
      address_str: address,
      landmark: data.landMark,
      city: data.city,
      state: data.state,
      country: "",
      pincode: data.zipCode,
      mobile: data.phoneNumber,
      is_default: formData.isDefault ?? false,
    };

    return await axiosInstance.post(user_apis.add_address(), params, {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

export const Delete_Address = async (userToken, id) => {
  try {
    return await axiosInstance.delete(user_apis.delete_address(id), {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

/**
 * Responds 202 on success, 406 with UserAddressErrorResponse on validation failure.
 * @param {Record<string, string>} data - Address form values
 * @param {{ addressType: AddressType | "", isDefault?: boolean }} formData
 * @param {number | null} addressId
 * @param {string} address - Goes to `address_str`
 * @returns {Promise<AxiosResponse<UserAddressMessageResponse>>}
 */
export const Edit_Address = async (data, formData, addressId, address) => {
  try {
    /** @type {UpdateUserAddressPayload} */
    const params = {
      first_name: data.firstName,
      last_name: data.lastName,
      type: formData.addressType,
      address_str: address,
      landmark: data.landMark,
      city: data.city,
      state: data.state,
      country: "Nepal",
      pincode: data.zipCode,
      mobile: data.phoneNumber,
      email: data.email,
      is_default: formData.isDefault ?? false,
    };
    return await axiosInstance.put(user_apis.edit_address(addressId), params, {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

/**
 * Soft-deletes the profile: wipes PII, removes addresses and blocks the user.
 * For vendors, also deactivates the store and all its products.
 * @param {string | null} [userToken] - Unused; the axios interceptor adds the token
 * @returns {Promise<AxiosResponse<BaseAPIMessageResponse>>}
 */
export const UserProfile_Delete = async (userToken) => {
  try {
    return await axiosInstance.delete(user_apis.user_profile_delete(), {
      // headers: {
      //   Authorization: "Token " + userToken,
      // },
      useUserToken: true,
      maxBodyLength: Infinity,
    });
  } catch (error) {
    throw error;
  }
};

export const Submit_Contact_Enquiry = async (name, email, phone, message) => {
  const data = {
    name,
    email,
    phone,
    message,
  };
  try {
    const response = await axiosInstance.post(
      user_apis.submit_contact_enquiry(),
      data,
      {
        useUserToken: false,
        maxBodyLength: Infinity,
      }
    );
    return response.data; // Return the API response
  } catch (error) {
    console.error("Contact enquiry submission failed:", error);
    throw error; // Throw error for the caller to handle
  }
};
